export default __webpack_public_path__ + "static/l8-portfolio-img-3-c7e80a277a869d15be6784cd54ee10c5.jpg";